import React from 'react';
import { findAllMentionsInContext } from '../utils/broadcastsUtils';

interface VerbalMentionContextBoxProps {
    context: string;
    mention: string;
}

const VerbalMentionContextBox = ({
    context,
    mention,
}: VerbalMentionContextBoxProps) => {
    const contextSubstrings = findAllMentionsInContext(context, mention);

    const containerStyle = {
        borderRadius: '8px',
        border: '0.5px solid #00000026',
    };

    const headerStyle = {
        fontSize: '16px',
        fontWeight: '600' as const,
        color: '#333',
        textAlign: 'center' as const,
        backgroundColor: '#0000000A',
        padding: '4px',
    };

    const contentStyle = {
        fontSize: '14px',
        padding: '4px',
    };

    const mentionStyle = {
        backgroundColor: '#FFD700',
        color: '#333',
        padding: '1px 2px',
        textDecoration: 'underline',
    };

    const renderContextSubstring = (substring: any, index: number) => {
        if (substring.isMention) {
            return (
                <span
                    key={`${index}-${substring.substring}`}
                    style={mentionStyle}
                >
                    {substring.substring}
                </span>
            );
        }
        return substring.substring;
    };

    return (
        <div style={containerStyle}>
            <div style={headerStyle}>
                Context
            </div>
            <div style={contentStyle}>
                {contextSubstrings.map(renderContextSubstring)}
            </div>
        </div>
    );
};

export default VerbalMentionContextBox;